var _style, _g, _rect, _rect2, _rect3, _rect4, _defs, _path, _path2, _path3, _defs2, _path4, _path5, _path6, _path7, _path8, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopasLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 302.2 46.6",
    style: {
      enableBackground: "new 0 0 302.2 46.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E7E7E7;}\n\t.st1{fill:#FFED00;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.665;stroke-miterlimit:2.613;}\n\t.st3{clip-path:url(#SVGID_2_);}\n\t.st4{clip-path:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -652.1,
    y1: 753.3,
    x2: -652.1,
    y2: 776.7
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 1,
    className: "st1",
    width: 45.2,
    height: 45.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 1,
    className: "st2",
    width: 45.2,
    height: 45.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 188.8,
    y: 1,
    className: "st1",
    width: 45.2,
    height: 45.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 188.8,
    y: 1,
    className: "st2",
    width: 45.2,
    height: 45.2
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -29.9,
    y: -29.2,
    width: 362,
    height: 135.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.3,3.9V1c8.9,0,18.1,0,27,0v2.9l-11.9,0v42.3h-3.2l0-42.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.2,3.3L50.2,3.3L50.2,3.3c-5.6,0-10.6,2.3-14.3,5.9C32.3,12.9,30,18,30,23.5c0,5.6,2.3,10.6,5.9,14.3 c3.7,3.7,8.7,5.9,14.2,5.9h0c5.6,0,10.6-2.3,14.2-5.9c3.7-3.7,5.9-8.7,5.9-14.3c0-5.6-2.3-10.6-5.9-14.3 C60.8,5.6,55.8,3.3,50.2,3.3 M50.2,0.4L50.2,0.4c6.4,0,12.2,2.6,16.4,6.8s6.8,10,6.8,16.3c0,6.4-2.6,12.2-6.8,16.4 s-10,6.8-16.4,6.8h0c-6.4,0-12.2-2.6-16.3-6.8s-6.8-10-6.8-16.4c0-6.4,2.6-12.2,6.8-16.3S43.8,0.4,50.2,0.4L50.2,0.4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5,28.3h-18.1l9-21.2L132.5,28.3z M142.9,46.2L123.5-0.5l-19.4,46.7h3.1l6.2-15h20.1l6.2,15H142.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -29.9,
    y: -29.2,
    width: 362,
    height: 135.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.2,25.7l-11-5.5c-8.6-4-6.4-16.8,2.8-19.2c10.6-2.8,15.7,6.2,15.3,5.9L169,8.6c-1.1-1-3.3-5.9-10.4-5.2 c-5.9,0.1-12.5,10.1-2.6,15.1l10.7,5.4c4.7,2.3,6.9,5.7,6.7,10c-0.2,7.5-7,12.8-14.4,12.8c-5.9,0-11.4-3-14-9.8l2.7-1.2 c2.3,5.5,6.3,8,11.2,8.1c5.6,0.1,11.2-4,11.3-10.5C170.3,29.6,167.7,27.7,164.2,25.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M241.6,8.8L252,26.9c0.5,0.8,1.4,1.3,2.3,1.3h32.5v2.9h-32.5c-2,0-3.9-1.1-4.8-2.9l-7.9-13.5V8.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M234.1,8.8l-10.4,18.1c-0.5,0.8-1.4,1.3-2.4,1.3h-32.5v2.9h32.5c2,0,3.9-1.1,4.8-2.9l7.9-13.5V8.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M294.8,4.1v2.2h0.8c0.8,0,1.4-0.1,1.7-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6 c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.8-0.3-1.7-0.3H294.8z M294,3.4h2.4c0.9,0,1.5,0.2,1.9,0.5c0.4,0.3,0.6,0.7,0.6,1.2 c0,0.5-0.2,0.9-0.6,1.3c-0.3,0.2-0.7,0.4-1.3,0.5c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.3,0.3,0.5,0.6c0.2,0.3,0.4,0.5,0.5,0.8 l0.6,1.1h-1l-0.6-1c-0.5-0.8-0.8-1.3-1.1-1.4c-0.2-0.2-0.6-0.2-1.2-0.2h-0.5v2.7H294V3.4z M301.3,6.7c0-1.4-0.5-2.7-1.5-3.6 c-1-1-2.2-1.5-3.7-1.5c-1.4,0-2.7,0.5-3.6,1.5c-1,1-1.5,2.2-1.5,3.6c0,1.4,0.5,2.7,1.5,3.7c1,1,2.2,1.5,3.6,1.5 c1.4,0,2.6-0.5,3.7-1.5C300.8,9.4,301.3,8.1,301.3,6.7 M301.9,6.7c0,1.6-0.5,3-1.7,4.1c-1.1,1.1-2.5,1.7-4.1,1.7s-3-0.6-4.1-1.7 c-1.1-1.1-1.7-2.5-1.7-4.1c0-1.6,0.6-3,1.7-4.1c1.1-1.1,2.5-1.7,4.1-1.7s3,0.6,4.1,1.7C301.4,3.7,301.9,5.1,301.9,6.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.4,12.9c0,4.9-4.1,9-9,9h-7v-18h7C96.3,3.9,100.4,7.9,100.4,12.9 M103.6,12.9c0-6.6-5.4-11.9-11.9-11.9 H81.1v45.3h3.3V24.8h7.4C98.2,24.8,103.6,19.4,103.6,12.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.8,44.6c3,0,5.4-2.4,5.4-5.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4C232.4,42.2,234.8,44.6,237.8,44.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopasLogo);
export default __webpack_public_path__ + "static/media/topas-logo.80e31843bf45cef273938f466046b94d.svg";
export { ForwardRef as ReactComponent };